module.exports = __webpack_public_path__ + "img/4-m.911744c2.jpg";